import request from "./reqest";
import store from "../store";
import Cookie from "./cookie";
import {roomUrl, windowsGoTo} from "./url";
import {language} from "../language/get";
import getParamter from "./util";
import { Notification, MessageBox, Message } from 'element-ui';
var initParam;
var initOnmessage;
//是否在直播间
var isRoom = false;
var resetConnectNum = 0;
var resetConnectId = '';
var wsUrl = "wss://jobxcx.wiffa-edu.com:8283";//正式
// var wsUrl = "wss://test.blnyingyu.com:8283";
function socketUrl(){
  return wsUrl;
}
function resetConnect(){
  if(resetConnectId == ''){

    console.log('-----------resetConnect------------')
    resetConnectId = setInterval(function(){
      if(resetConnectNum >= 3){
        clearInterval(resetConnectId)
        MessageBox({
          title: "",
          message: language().networkDisconnect,
          confirmButtonText: language().confirm,
          cancelButtonText: language().cancel,
          showCancelButton: false,
          // type: 'warning'
        }).then(() => {
          //确认
          if (location.pathname == "/livestudio.html") {
            window.history.go(-1);
          }
        }).catch(() => {
          //取消
        });


        return;
      }
      resetConnectNum++;
      init(initParam, initOnmessage)
      console.log('-----------resetConnect------------',resetConnectNum)

    }, 5000);
  }
}
function getWebSocket(callback, heartBeatParam) {
  console.log('--------getWebSocket-----------')
  let data = {};
  const socket = new WebSocket(wsUrl);
  socket.onopen = (e) => {
    console.log("连接成功");
    //心跳包 30秒一次
  };
  /**
   * 方法将需要通过 WebSocket
   * 链接传输至服务器的数据排入队列，
   * 并根据所需要传输的data bytes的大小来增加
   * bufferedAmount的值
   */
  socket.onmessage = (e) => {
    //将字符串转换成JSON对象
    try {
      data = JSON.parse(e.data);
      console.log('-----onmessage-------',data)
      if(data.type == 'allNotice'){
          if(data.lan == Cookie.get("lang")){
            Notification({
                title: Cookie.get("lang")=="ch"?'通知':'Bulletin Board',
                dangerouslyUseHTMLString: true,
                message: data.msg,
                duration: 0,
                position: 'bottom-right'
            })
            showHiddenNotify();
          }
        return;
      }else if(data.type == 'refuseMsg'){
        //拒绝消息提醒
        MessageBox({
          title: "",
          message: data.msg,
          confirmButtonText: language().confirm,
          cancelButtonText: language().cancel,
          showCancelButton: false,
          // type: 'warning'
        }).then(() => {
          //确认
        }).catch(() => {
          //取消
        });
        return;
      }
      var type = data.data.type;
      if(type == 'subscribeRemindMsg'){
        console.log('-----subscribeRemindMsg-------',location.href)
        //预约时间提前2分钟提醒
        let broadcast_id = data.data.broadcast_id;
        MessageBox({
          title: "",
          message: Cookie.get("lang")=="ch" ? data.data.text : data.data.text_en,
          confirmButtonText: language().confirm,
          cancelButtonText: language().cancel,
          showCancelButton: false,
          // type: 'success'
        }).then(() => {
          //确认
          request.send('/Live/Live_Url', JSON.stringify({broadcast_id: broadcast_id})).then((res) => {
            if (res.type == 1) {
              let name = Cookie.get("lang") == 'ch' ? (store.getters.userInfo.true_name || store.getters.userInfo.true_name_en) : (store.getters.userInfo.true_name_en || store.getters.userInfo.true_name);
              window.location.href = windowsGoTo() + roomUrl(res.data[0], name);
            } else if (res.type == 11){
              MessageBox({
                title: "",
                message: Cookie.get("lang")=='ch'?res.text:res.text_en,
                confirmButtonText: language().confirm,
                cancelButtonText: language().cancel,
                showCancelButton: false,
                // type: 'success'
              }).then(() => {
                //确认
              }).catch(() => {
                //取消
              });
            }else {
              Message.error({ message: Cookie.get("lang")=='ch'?res.text:res.text_en, offset: 120 });
            }
          });
        }).catch(() => {
          //取消
        });
      }else if(type == 'inviteUsersMsg'){
        console.log('-----inviteUsersMsg-------',location.href);

        let exhibitionId = getParamter.getQueryString("exhibition_id");
        if (location.href.indexOf('forum.html') >= 0 && exhibitionId == data.data.exhibition_id) {
          //空闲直播间提醒
          let broadcast_id = data.data.broadcast_id;
        console.log('-----显示空闲通知-------');
          // console.log(broadcast_id);
          Notification({
              title: Cookie.get("lang")=="ch"?'通知':'Bulletin Board',
              dangerouslyUseHTMLString: true,
              message: "<span style=\"cursor:pointer;\">" + (Cookie.get("lang")=="ch" ? data.data.text : data.data.text_en) + "</span>",
              duration: (1000*30),
              position: 'bottom-right',
              onClose: function () {
              },
              onClick: function(){
                //判断是否登录
                if(store.getters.token == null || store.getters.token == undefined){
                  MessageBox({
                    title: "",
                    message: "你还未登录，请先登录，若无账号请先注册",
                    cancelButtonClass:"regClass",
                    confirmButtonClass:"loginClass",
                    confirmButtonText: language().login,
                    cancelButtonText: language().register,
                    showCancelButton: true,
                  }).then(() => {
                    //确认
                    window.location.href="login.html";
                  }).catch(() => {
                    //取消
                    window.location.href="register.html";
                  });
                  return;
                };
                request.send('/Live/Live_Url', JSON.stringify({broadcast_id: broadcast_id})).then((res) => {
                  // debugger;
                  // console.log("---  " , store.getters.token);
                  // console.log("消息==" , res);

                  //判断是否是招聘企业
                  if(store.getters.userInfo.user_nature == 3 && res.data.user_id != store.getters.userInfo.user_id) {
                    MessageBox({
                      title: "",
                      message: "您作为招聘企业不能参加其他公司的面试",
                      confirmButtonText: language().confirm,
                      cancelButtonText: language().cancel,
                      showCancelButton: false,
                    }).then(() => {
                      //确认
                    }).catch(() => {
                      //取消
                    });
                    return;
                  };
                  if (res.type == 1) {
                    let name = Cookie.get("lang") == 'ch' ? (store.getters.userInfo.true_name || store.getters.userInfo.true_name_en) : (store.getters.userInfo.true_name_en || store.getters.userInfo.true_name);
                    window.location.href = windowsGoTo() + roomUrl(res.data[0], name);
                  } else if (res.type == 11){
                    MessageBox({
                      title: "",
                      message: Cookie.get("lang")=='ch'?res.text:res.text_en,
                      confirmButtonText: language().confirm,
                      cancelButtonText: language().cancel,
                      showCancelButton: false,
                      // type: 'success'
                    }).then(() => {
                      //确认
                    }).catch(() => {
                      //取消
                    });
                  }else if (res.type == 'e1'){
                    //没有购票
                    MessageBox({
                      title: "",
                      message: Cookie.get("lang")=='ch'?res.text:res.text_en,
                      confirmButtonText: language().buyTicket,
                      cancelButtonText: language().cancel,
                      showCancelButton: true,
                      // type: 'error'
                    }).then(() => {
                      //确认
                      let params = "exhibitionId=" + exhibitionId;
                      let encodeData = window.btoa(window.encodeURIComponent(params));
                      localStorage.setItem("buyBackUrl", location.href);
                      window.location.href = "ticketsRegister.html?" + encodeData;
                    }).catch(() => {
                      //取消
                    });
                  } else{
                    Message.error({ message: Cookie.get("lang")=='ch'?res.text:res.text_en, offset: 120 });
                  }
                });
              }
          });
          // showFoldNotify();
          showHiddenNotify();
        }

      }
      callback(data);
    } catch (e) {

    }
  }
  // 当客户端收到服务端发送的关闭连接请求时，触发onclose事件
  socket.onclose = (e) => {
    resetConnect();
  }


  //如果出现连接、处理、接收、发送数据失败的时候触发onerror事件
  socket.onerror = (e) => {
    resetConnect();
  }
  return socket;
}
function send(socket, data) {
  data = data || {
    type: 2,
    data: 'heart beat'
  }

  console.log('------ socket sebd ---------', data)
  socket.send(JSON.stringify(data));
}
function init(param, onmessage) {
  initParam = param
  initOnmessage = onmessage
  // if (store.getters.token) {
    console.log('------ 获取store ---------')
    var socket = getWebSocket((data) => {
      console.log('------ 获取store成功 ---------')
      console.log(data)
      resetConnectNum = 0;
      clearInterval(resetConnectId);
      resetConnectId = '';
      var type = data.data.type;
      // type=1代表成功
      if (type == 1) {
        var requestData = {
          client_id: data.data.client_id,
          token: param.token
        }
        store.commit('setClientId',data.data.client_id)
        // console.log('###@@###@@##@@##@@',data.data.client_id);

        if (param.roomId) {
          requestData.roomid = param.roomId;
        }
        // if (param.heartBeatParam.roomid) {
        //   isRoom = true;
        // }else {
        //   isRoom = false
        // }
        if(store.getters.token) {
          request.send('/Gateway/Bind_user', JSON.stringify(requestData)).then((res) => {
            if (res.type == 1) {
              if (param.goRoomParam) {
                request.send('/Gateway/Go_Room', JSON.stringify(param.goRoomParam)).then((res) => {
                  if (res.type == 1) {
                    send(socket, param.heartBeatParam);
                    setInterval(() => {
                      send(socket, param.heartBeatParam);
                    }, 30000);

                    param.goRoomCall(res);
                  } else {
                    //alert('进入失败,请重试');
                    history.go(-1);
                  }
                });
              } else {
                send(socket, param.heartBeatParam);
                setInterval(() => {
                  send(socket, param.heartBeatParam);
                }, 30000);
              }
            }
          });
        }
      }
      onmessage(data);
    }, param.heartBeatParam);
    return socket;
  // }
  // return null;
}
export {
  socketUrl,
  getWebSocket,
  init
};
function showFoldNotify() {
  let openText = Cookie.get("lang")=="ch"?"展开":"open";
  let closeText = Cookie.get("lang")=="ch"?"收起":"close";
  if (!$('#fold-notify').length) {
    $("body").append("<div id='fold-notify'" +
        " style='writing-mode: vertical-lr;cursor: pointer; z-index: 200; position: fixed; bottom: 18px; right: 345px; width: 22px; color: #999; height: 43px; text-align: center; background: white;'" +
        " class='fold-notify'>"+closeText+"</div>");
    $('#fold-notify').click(function () {
      if($(this).text() == openText){

        $('.el-notification').css('right', '16px');
        $(this).css('right', '345px');
        $(this).text(closeText);
      }else{
        $('.el-notification').css('right', '-1000px');
        $(this).css('right', '0px');
        $(this).text(openText);
      }

      //$('#fold-notify').hide();
    });
  } else {
    $('#fold-notify').show();
      $('.el-notification').css('right', '16px');
      $('#fold-notify').css('right', '345px');
      $('#fold-notify').text(closeText);
    //$('.el-notification').show();
  }
  if (!window.foldNotifyTimer) {
    window.foldNotifyTimer= setInterval(function () {
      console.log('interval');
      if ($('.el-notification').length == 0) {
        $('#fold-notify').hide();
        window.clearInterval(window.foldNotifyTimer);
        window.foldNotifyTimer = null;
      }
    }, 200);
  }
}

function showHiddenNotify() {
  let openText = Cookie.get("lang")=="ch"?"展开":"open";
  let closeText = Cookie.get("lang")=="ch"?"收起":"close";
  if (!$('#fold-notify').length) {
    $("body").append("<div id='fold-notify'" +
        " style='writing-mode: vertical-lr;cursor: pointer; z-index: 200; position: fixed; bottom: 18px; right: 345px; width: 22px; color: #333333; height: 43px; text-align: center; background: white;margin-left: 4px;'" +
        " class='fold-notify'>"+closeText+"</div>");
    $('#fold-notify').click(function () {
      if($(this).text() == openText){

        $('.el-notification').css('right', '16px');
        $(this).css('right', '345px');
        $(this).css({'width':'22px','height':'43px','background':'white','color':'#333333'});
        $(this).text(closeText);
      }else{
        $('.el-notification').css('right', '-1000px');
        $(this).css('right', '120px');
        $(this).text(openText);
        $(this).css({'width':'80px','height':'80px','background':'transparent','color':'transparent'});
        $(this).append("<img src='imgs/shouyexiaoxi.png' style='width: 65px;height: 65px;'>")
      }

      //$('#fold-notify').hide();
    });
  } else {
    $('#fold-notify').show();
    $('.el-notification').css('right', '16px');
    $('#fold-notify').css('right', '345px');
    $('#fold-notify').css({'width':'22px','height':'43px','background':'white','color':'#333333'});
    $('#fold-notify').text(closeText);
    //$('.el-notification').show();
  }
  if (!window.foldNotifyTimer) {
    window.foldNotifyTimer= setInterval(function () {
      // console.log('interval');
      if ($('.el-notification').length == 0) {
        $('#fold-notify').hide();
        window.clearInterval(window.foldNotifyTimer);
        window.foldNotifyTimer = null;
      }
    }, 100);
  }
}
